import { useJobSiteTemporaryFormStore } from '@/store/JobSiteTemporaryFormStore';

export function useJobSiteTemporaryFormData() {
  const { formData, setFormData, clearFormData } = useJobSiteTemporaryFormStore();

  return {
    jobSiteFormData: formData,
    setJobSiteFormData: setFormData,
    clearJobSiteFormData: clearFormData
  };
}
